(function($) {
  const INSURANCE_PRODUCT_TYPE = 'Package Protection';
  const SHIPPING_INSURANCE = shipping_insurance;
  
  function formatMoney(value) {
    return Shopify.formatMoney(value, $('body').data('money-format'));
  }
    
  function getCart() {
    return $.getJSON('/cart.js');
  }
  
  function updateCart(updates) {
    if (!updates) {
      return;
    }
    
    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        async: true,      
        data: {updates: updates},
        dataType: 'json',
        success: function(data) { 
          //console.log(data);
          resolve(data);
        },
        error: function(error) { 
          console.error(error);
          reject(error);
        }
      });
    });    
  }  
  
  function refreshCart() {
    getCart().then(function(cart) {
      $('.ajax-cart__subtotal').find('span.money').html(formatMoney(cart.items_subtotal_price));
      $('.cart__subtotal').find('span.money').html(formatMoney(cart.items_subtotal_price));
    });
  }
  
  function getCartTotalMinusInsurance(cart) {
    var items_without_insurance = cart.items.filter(function(item) {
      return item.product_type !== INSURANCE_PRODUCT_TYPE;
    });
    
    var total = items_without_insurance.reduce(function(sum, item) {
      return sum + item.final_line_price;
    }, 0);
    
    return total;
  }
  
  function getInsuranceVariant(cart) {
    var total = getCartTotalMinusInsurance(cart);
    var insurance_variant = SHIPPING_INSURANCE.variants[0];    
    
    if (total >= 9800) {
      insurance_variant = SHIPPING_INSURANCE.variants.filter(function(variant) {
        return variant.price >= cart.total_price * 0.01;
      })[0];
    }
    
    return insurance_variant;
  }
  
  function updateInsurance() {    
    getCart().then(function(cart) {
      var insurance_variant_to_add = getInsuranceVariant(cart);
      var insurance_variant_in_cart = cart.items.find(function(item) {
        return item.product_type == INSURANCE_PRODUCT_TYPE;
      });
      var standard_items_in_cart = cart.items.filter(function(item) {
        return item.product_type !== INSURANCE_PRODUCT_TYPE;
      });
      
      var isDisabled = JSON.parse(sessionStorage.getItem('insurance_disabled'));
      $('.shipping-insurance input[type=checkbox]').prop('checked', !isDisabled);      
      
      var insurance_price = formatMoney(insurance_variant_to_add.price);
      $('.shipping-insurance .price').html(insurance_price);
      
      // If checkbox checked, update insurance variant in cart
      var addInsurance = !JSON.parse(sessionStorage.getItem('insurance_disabled'));

      var updates = {};
      if (insurance_variant_in_cart) {
        updates[insurance_variant_in_cart.id] = 0;
      }
      if (insurance_variant_in_cart && standard_items_in_cart.length == 0) {
        updates[insurance_variant_in_cart.id] = 0;
      }
      
      if (addInsurance) {
        if (standard_items_in_cart.length > 0) {
          updates[insurance_variant_to_add.id] = 1;
        }
      }
      //console.log(updates);
      
      updateCart(updates).then(refreshCart)
    });
  }
  
  function shippingInsurance() {
    updateInsurance();
    
    // on cart update
    $(document).on('cart:updated', function(e) {
      //console.log(e);
      updateInsurance();
    });
    
    // On label click
    $(document).on('click', '.shipping-insurance label', function(e) {
      var $checkbox = $(e.currentTarget).closest('.shipping-insurance').find('input[type="checkbox"]');
      $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
    });    
    
    // On checkbox change
    $(document).on('change', '.shipping-insurance input[type=checkbox]', function(e) {
      var isDisabled = !$(e.currentTarget).prop('checked');
      sessionStorage.setItem('insurance_disabled', isDisabled);
      
      updateInsurance();
    });
    
    // info modal
    $(document).on('click', '.shipping-insurance .more-info', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $.fancybox.open('<div class="shipping-insurance-modal"><div class="text-center"><img src="' + SHIPPING_INSURANCE.images[0] + '"></div>' + SHIPPING_INSURANCE.description + '</div>');
    });
  }


  $(document).ready(function() {
    shippingInsurance();
  });
})(jQuery);
